import _ from 'underscore'
import WStringManipulationMixin from '../mixins/w-string-manipulation-mixin'

/**
 * @mixin
 */
export default {
    mixins: [WStringManipulationMixin],
    computed: {
        formErrorAlertsFormatted () {
            return (errors) => {
                let errorMessages = []

                if (_.isEmpty(errors)) {
                    return errorMessages
                }

                errorMessages = _.map(errors, (error) => {
                    if (_.has(error, 'field') && !_.isEmpty(error.field)) {
                        return `${this.formatAsTitle(error.field)}: ${error.message}`
                    }

                    return error.message
                })

                return [{
                    show: true,
                    type: 'error',
                    content: {
                        type: 'text',
                        data: !_.isEmpty(errorMessages)
                            ? _.uniq(errorMessages)
                            : ['There was an error processing this form']
                    }
                }]
            }
        }
    }
}
